import {ActionIcon, Avatar, Group, Stack, StackProps, Text} from "@mantine/core";
import {IconEdit, IconTrash, IconUser} from "@tabler/icons-react";
import {FormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";
import {useTranslation} from "react-i18next";
import {MessageEntity} from "@ots-frontend/ots-data";

export interface CommentProps extends StackProps {
  comment: string
  dttm?: Date | number
  personName?: string
  onEdit?: () => void
  onDelete?: () => void
}

export const makeCommentProps = (
  message: MessageEntity,
  onEdit: ((message: MessageEntity) => void) | undefined = undefined,
  onDelete: ((message: MessageEntity) => void) | undefined = undefined,
  props: StackProps = {}
): CommentProps => {

  return {
    ...props,
    comment: message.message,
    dttm: message.createDttm,
    personName: message.personName,
    onEdit: onEdit ? () => onEdit(message) : undefined,
    onDelete: onDelete ? () => onDelete(message) : undefined,
  }
}

export const Comment = (props: CommentProps) => {
  const {comment, dttm, personName, onEdit, onDelete, ...rest} = props

  const {t} = useTranslation()

  return (
    <Stack {...rest}>
      <Group>
        <Avatar radius="xl">
          <IconUser size="1.5rem"/>
        </Avatar>
        <div>
          <Text size="sm">
            {personName ?? t("common.shared.unknown", "Unknown")}
          </Text>
          <Text size="xs" c="dimmed">
            <FormattedDateTime date={dttm}/>
          </Text>
        </div>
      </Group>
      <Text pl={54} size="sm">
        {comment}
      </Text>
      {(onEdit || onDelete) && (
        <Group spacing={4} position="right" noWrap>
          {onEdit &&
            <ActionIcon onClick={() => onEdit()}>
              <IconEdit size={16}/>
            </ActionIcon>
          }
          {onDelete &&
            <ActionIcon color="red" onClick={() => onDelete()}>
              <IconTrash size={16}/>
            </ActionIcon>
          }
        </Group>
      )}
    </Stack>
  )
}
